/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digest_FailedInputs */

const en_digest_failed = /** @type {(inputs: Digest_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The digest could not change.`)
};

/**
* | output |
* | --- |
* | "The digest could not change." |
*
* @param {Digest_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const digest_failed = /** @type {((inputs?: Digest_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digest_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_digest_failed(inputs)
});